// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[type=\"file\"][data-v-372f4369] {\n  width: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
